import { useContext } from "react";
import { Navigate } from "react-router-dom";
import { AuthContext } from "./AuthContext";

const ProtectedRoute = ({
  children,
  requireAdmin = false,
  requireAssistant = false,
  requireStudent = false,
  requireEnrolled = false,
  allowIncomplete = false
}) => {
  const { user, role, loading, enrolledCourse } = useContext(AuthContext);

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-teal-500"></div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  const isStaff = role === "admin" || role === "assistant" || role === "superadmin";

  // For staff, always bypass enrollment checks
  if (isStaff) {
    if (requireAssistant && role !== "assistant") {
      return <Navigate to="/admin" replace />;
    }
    if (requireAdmin && !(role === "admin" || role === "superadmin")) {
      return <Navigate to="/dashboard" replace />;
    }
    return children;
  }

  // Enrollment requirements apply to students (or routes that explicitly require it)
  if ((requireEnrolled || requireStudent || role === "student") && !allowIncomplete) {
    if (!enrolledCourse) {
      return <Navigate to="/complete-registration" replace />;
    }
    if (enrolledCourse === "pending_registration" && window.location.pathname !== "/complete-registration") {
      return <Navigate to="/complete-registration" replace />;
    }
  }

  if (!allowIncomplete) {
    if (requireAdmin && role !== "admin") {
      return <Navigate to="/dashboard" replace />;
    }

    if (requireAssistant && role !== "assistant") {
      return <Navigate to="/dashboard" replace />;
    }

    if (requireStudent && role !== "student") {
      return <Navigate to="/dashboard" replace />;
    }
  }

  return children;
};

export default ProtectedRoute;